import { useEffect, useState } from 'react';
import { PqrStatusHistoryProps } from './props';
import { asyncGetPqrStatusHistory } from '../../../../../services/pqr.service';
import { GridColDef } from '@mui/x-data-grid';
import { TableTooltip } from '../../../../components/general/table';
import { PqrStatusHistory } from '../../../../../shared/types/modules/pqr';
import { ISelect } from '../../../../../shared/types/shared';
import DateTimeFormat from '../../../../components/dateTimeFormat';

export const usePqrStatusHistory = ({ id }: PqrStatusHistoryProps) => {
    const [loadingStatusHistory, setLoading] = useState(false);
    const [openStatusHistoryModal, setOpenStatusHistoryModal] = useState(false);
    const [total, setTotal] = useState<number>(0);
    const [rows, setRows] = useState<PqrStatusHistory[]>([]);

    useEffect(() => {
        const shouldFetch =
            Boolean((id as string)?.trim()) && openStatusHistoryModal;

        if (shouldFetch) {
            setLoading(true);
            asyncGetPqrStatusHistory((id as string).trim())
                .then((status) => {
                    setRows(status.items);
                    setTotal(status.length);
                })
                .finally(() => setLoading(false));
        }
    }, [id, openStatusHistoryModal]);

    const handleCloseStatusHistoryModal = () => {
        setOpenStatusHistoryModal(false);
    };

    const columnsStatusHistory: GridColDef<PqrStatusHistory>[] = [
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.createdBy?.username || ''} />
            ),
        },
        {
            field: 'email',
            headerName: 'Email',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.pqrId?.account?.email || ''} />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={(row.row.changes.info?.status as ISelect)?.name}
                />
            ),
        },
        {
            field: 'observation',
            headerName: 'Observaciones',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.changes.statusManagement?.observation ||
                        row.row.previousState?.statusManagement?.observation ||
                        row.row.changes.info?.detail ||
                        ''
                    }
                />
            ),
        },
        {
            field: 'attach',
            headerName: 'Anexo',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.changes.attachments
                            ?.map((item) => item.name)
                            .join(', ') || ''
                    }
                />
            ),
        },
    ];

    return {
        openStatusHistoryModal,
        setOpenStatusHistoryModal,
        handleCloseStatusHistoryModal,
        loadingStatusHistory,
        columnsStatusHistory,
        total,
        rows,
    };
};
